import { emitMixpanelUserEvent, UserTrackingEvents } from '@revelio/core';
import { RevelioTooltip, type RevelioTooltipProps } from '@revelio/ui';

export interface WithTooltipProps extends Omit<RevelioTooltipProps, 'onOpen'> {
  showCondition: boolean;
  tooltipId: string;
}

export const WithTooltip = ({
  showCondition,
  tooltipId,
  children,
  ...tooltipProps
}: WithTooltipProps) =>
  showCondition ? (
    <RevelioTooltip
      placement="top"
      onOpen={() => {
        emitMixpanelUserEvent(UserTrackingEvents.TOOLTIP_OPEN, {
          tooltip_id: tooltipId,
        });
      }}
      {...tooltipProps}
    >
      {children}
    </RevelioTooltip>
  ) : (
    children
  );
